import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { ExaminationStatusSearchRequest } from "../api-interfaces";
import { DEFAULT_PAGE_SIZE, TableConfig } from "../../configs/constants";

interface ExaminationsStatusList {
  searchCriteria: ExaminationStatusSearchRequest;
  tableConfig: TableConfig;
}

export const INITIAL_SEARCH_CRITERIA: ExaminationStatusSearchRequest = {
  checkTargetCode: 1,
  contractServiceCode: "",
  examinationApplicationNoList: [],
  applicationNoList: [],
  beforeExaminationStatusFlg: false,
  underExaminationStatusFlg: false,
  completedExaminationStatusFlg: false,
  comprehensiveExaminationOkFlg: false,
  comprehensiveExaminationNgFlg: false,
  comprehensiveExaminationWaitingForRequestFlg: false,
  comprehensiveExaminationApprovalPendingFlg: false,
  enRouteExaminationNgAdsFlg: false,
  enRouteExaminationNgOmniFlg: false,
  nttFixedCreditNgFlg: false,
  vmOrderTargetCodeFlg: false,
  vmOrderTargetCodeNullFlg: false,
  corporateNumber: "",
  companyName: "",
  merchantName: "",
  examinationApplicationStartDate: "",
  examinationApplicationEndDate: "",
  settlementGroupId: "",
  accessKey: "",
  contractRoute: "1",
  contractRouteName: "",
  acquirer: "1",
  smccFlg: false,
  tfFlg: false,
  saisonFlg: false,
  jcbFlg: false,
  amexFlg: false,
  creditBeforeExaminationStatusFlg: false,
  creditUnderExaminationStatusFlg: false,
  creditCompletedExaminationStatusFlg: false,
  normalExaminationFlg: false,
  tenantExaminationFlg: false,
  examinationTypeNewExaminationFlg: false,
  examinationTypeChangeExaminationFlg: false,
  examinationTypeCancellationFlg: false,
  posRegisterApplicationStartDate: "",
  posRegisterApplicationEndDate: "",
  posAcquirer: "1",
  posBeforeApplicationFlg: false,
  posUnderApplicationFlg: false,
  posCompletedApplicationFlg: false,
  docomoExaminationApplicationStartDate: "",
  docomoExaminationApplicationEndDate: "",
  docomoBeforeExaminationFlg: false,
  docomoUnderExaminationFlg: false,
  docomoCompletedExaminationFlg: false,
  docomoNormalExaminationFlg: false,
  docomoTenantExaminationFlg: false,
  timestamp: -1,
};

const initialState: ExaminationsStatusList = {
  searchCriteria: INITIAL_SEARCH_CRITERIA,
  tableConfig: {
    pageSize: DEFAULT_PAGE_SIZE,
    pageIndex: 1,
    columnWidths: [],
  },
};
const examinationsStatusListSlice = createSlice({
  name: "examinationsStatusList",
  initialState,
  reducers: {
    setSearchCriteria: (
      state,
      action: PayloadAction<ExaminationStatusSearchRequest>
    ) => {
      state.searchCriteria = action.payload;
      state.tableConfig = {
        pageSize: DEFAULT_PAGE_SIZE,
        pageIndex: 1,
        columnWidths: [],
      };
    },
    setPageIndex: (state, action: PayloadAction<number>) => {
      state.tableConfig.pageIndex = action.payload;
    },
    setColumnWidths: (state, action: PayloadAction<number[]>) => {
      state.tableConfig.columnWidths = action.payload;
    },
    changePageSize: (state, action: PayloadAction<number>) => {
      state.tableConfig.pageSize = action.payload;
      state.tableConfig.pageIndex = 1;
    },
  },
});

export const {
  setSearchCriteria,
  setPageIndex,
  setColumnWidths,
  changePageSize,
} = examinationsStatusListSlice.actions;

export default examinationsStatusListSlice.reducer;
